import { render, staticRenderFns } from "./NavMenuGroup.vue?vue&type=template&id=db6878da&scoped=true"
import script from "./NavMenuGroup.vue?vue&type=script&lang=js"
export * from "./NavMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./NavMenuGroup.vue?vue&type=style&index=0&id=db6878da&prod&lang=scss&scoped=true"
import style1 from "./NavMenuGroup.vue?vue&type=style&index=1&id=db6878da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6878da",
  null
  
)

export default component.exports